import apiClient from "../../axios/apiClient";


export const getMasterSettings = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_SETTINGS_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Settings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_SETTINGS_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_SETTINGS_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAllStateList =
  (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_STATE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/State`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_STATE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_STATE_REJECTED",
        payload: error.response,
      });
    }
  };

  export const getAllCategoryList =
  (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CATEGORY_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Category-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_CATEGORY_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_CATEGORY_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAllCityStateWiseList= (token, stateId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CITY_STATE_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/City`,
        {
          params: {
            state_id: stateId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      // console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_CITY_STATE_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      if (error.response) {
        console.error('Error Response Data:', error.response.data);
        console.error('Error Response Status:', error.response.status);
        console.error('Error Response Headers:', error.response.headers);
      }
      dispatch({
        type: "GET_MASTER_CITY_STATE_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterUsertypeUserWiseList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USERTYPE_USER_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Usertype`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_WISE_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterFieldOfficerList= (token, case_id= null) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_FIELD_OFFICER_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/All-Fo-List${case_id ? `?case_id=${case_id}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_FIELD_OFFICER_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_FIELD_OFFICER_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterBackendOfficerList= (token, case_id= null) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_BACKEND_OFFICER_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/All-Bo-List${case_id ? `?case_id=${case_id}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_BACKEND_OFFICER_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_BACKEND_OFFICER_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterCaseManagerList= (token, case_id= null) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CASE_MANAGER_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/All-Case-Manager-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_CASE_MANAGER_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_CASE_MANAGER_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterUserUserTypeWiseList= (token, user_type_id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USER_USERTYPE_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/User-Usertype-Wise`,
        {
          params: {
            user_type_id: user_type_id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      // console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_USER_USERTYPE_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      if (error.response) {
        console.error('Error Response Data:', error.response.data);
        console.error('Error Response Status:', error.response.status);
        console.error('Error Response Headers:', error.response.headers);
      }
      dispatch({
        type: "GET_MASTER_USER_USERTYPE_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


  export const getMasterAllUserList= (token, user_type_id) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MASTER_USER_USERTYPE_WISE_PENDING" });
  
        const response = await apiClient.get(
          `/api/admin/v1/Master/All-User-List`,
          {
            params: {
              user_type_id: user_type_id,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json"
            },
          }
        );
        // console.log('response.data?.data',response.data?.data);
        dispatch({
          type: "GET_MASTER_USER_USERTYPE_WISE_FULFILLED",
          payload: response.data?.data,
        });
      } catch (error) {
        console.log(error);
        if (error.response) {
          console.error('Error Response Data:', error.response.data);
          console.error('Error Response Status:', error.response.status);
          console.error('Error Response Headers:', error.response.headers);
        }
        dispatch({
          type: "GET_MASTER_USER_USERTYPE_WISE_REJECTED",
          payload: error.response,
        });
      }
    };

export const getMasterInsuranceList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_INSURANCE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Insurance-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_INSURANCE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_INSURANCE_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterInsuranceTpaList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_INSURANCE_TPA_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Insurance-TPA-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_INSURANCE_TPA_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_INSURANCE_TPA_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllInsuranceManagerWiseList= (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_INSURANCE_MANAGER_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Insurance-Manager-List/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      // console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_INSURANCE_MANAGER_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      if (error.response) {
        console.error('Error Response Data:', error.response.data);
        console.error('Error Response Status:', error.response.status);
        console.error('Error Response Headers:', error.response.headers);
      }
      dispatch({
        type: "GET_MASTER_INSURANCE_MANAGER_WISE_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterDesignationList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_DESIGNATION_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Designation-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_DESIGNATION_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_DESIGNATION_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterHospitalList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_HOSPITAL_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Hospital-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_HOSPITAL_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_HOSPITAL_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllRelationshipList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_RELATIONSHIP_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Relationship-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_RELATIONSHIP_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_RELATIONSHIP_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllOccupationList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_OCCUPATION_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Occupation-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_OCCUPATION_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_OCCUPATION_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllLocalityList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_LOCALITY_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Locality-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_LOCALITY_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_LOCALITY_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllEducationalList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_EDUCATION_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Education-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_EDUCATION_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_EDUCATION_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllJobList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_JOB_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Job-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_JOB_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_JOB_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllRoomCategoryList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_ROOM_CATEGORY_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Room-Type-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_ROOM_CATEGORY_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_ROOM_CATEGORY_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllIncomeDetailsList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_INCOME_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Income-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_INCOME_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_INCOME_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllInjuryTypeList= (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_INJURY_TYPE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Injury-Type-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_INJURY_TYPE_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_INJURY_TYPE_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterClaimTypeList = (token, type) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CLAIM_TYPE_PENDING" });

      const requestConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      if (type) {
        requestConfig.params = { type };
      }

      const response = await apiClient.get(
        `/api/admin/v1/Master/Claim-Type-List`,
        requestConfig
      );
      dispatch({
        type: "GET_MASTER_CLAIM_TYPE_FULFILLED",
        payload: response.data?.data,
      });
    }
    catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_CLAIM_TYPE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAllCheckList =
  (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CHECKLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Checklist`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_CHECKLIST_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_CHECKLIST_REJECTED",
        payload: error.response,
      });
    }
  };

export const getAllCityList =
  (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_ALL_CITY_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/All-City`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_ALL_CITY_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_ALL_CITY_REJECTED",
        payload: error.response,
      });
    }
  };



export const getGeofenceList =
(token) =>
async (dispatch) => {
  try {
    dispatch({ type: "GET_MASTER_GEOFENCE_PENDING" });

    const response = await apiClient.get(
      `/api/admin/v1/Master/Geofence-List`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    //console.log('response.data?.data',response.data?.data);
    dispatch({
      type: "GET_MASTER_GEOFENCE_FULFILLED",
      payload: response.data?.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "GET_MASTER_GEOFENCE_REJECTED",
      payload: error.response,
    });
  }
};


export const getMasterTodayAbsenceList =
(token) =>
async (dispatch) => {
  try {
    dispatch({ type: "GET_MASTER_ABSENCE_PENDING" });

    const response = await apiClient.get(
      `/api/admin/v1/Master/Today-Absent-List`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    //console.log('response.data?.data',response.data?.data);
    dispatch({
      type: "GET_MASTER_ABSENCE_FULFILLED",
      payload: response.data?.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "GET_MASTER_ABSENCE_REJECTED",
      payload: error.response,
    });
  }
};


export const getMasterAllCheckSubList =
  (token) =>
  async (dispatch) => {
  try {
    dispatch({ type: "GET_MASTER_ALL_CHECKLIST_PENDING" });

    const response = await apiClient.get(
      `/api/admin/v1/Master/Get-Check-Sub-List`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    //console.log('response.data?.data',response.data?.data);
    dispatch({
      type: "GET_MASTER_ALL_CHECKLIST_FULFILLED",
      payload: response.data?.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "GET_MASTER_ALL_CHECKLIST_REJECTED",
      payload: error.response,
    });
  }
};

export const getMasterUserTypeWalletList =
  (token, userTypeId, limit, page, search = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USER_TYPE_WALLET_LIST_PENDING" });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Optional pagination/search params, similar to TripReport
      if (
        typeof limit !== "undefined" ||
        typeof page !== "undefined" ||
        (search && search.trim() !== "")
      ) {
        config.params = {
          ...(typeof limit !== "undefined" ? { limit } : {}),
          ...(typeof page !== "undefined" ? { page } : {}),
          ...(search && search.trim() !== "" ? { search: search.trim() } : {}),
        };
      }

      const response = await apiClient.get(
        `/api/admin/v1/Get-User-List-By-Usertype/${userTypeId}`,
        config
      );

      const data = response.data?.data ?? [];
      const countFromApi = response.data?.count;

      dispatch({
        type: "GET_MASTER_USER_TYPE_WALLET_LIST_FULFILLED",
        payload: data,
        count:
          typeof countFromApi === "number"
            ? countFromApi
            : Array.isArray(data)
            ? data.length
            : 0,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_USER_TYPE_WALLET_LIST_REJECTED",
        payload: error.response,
      });
    }
  };

export const getUserWalletDetails =
  (token, userId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USER_WALLET_DETAILS_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/User-Wallet-Details/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data?.data ?? [];
      const countFromApi = response.data?.count;
      const currentBalanceFromApi = response.data?.currentBalance;

      dispatch({
        type: "GET_USER_WALLET_DETAILS_FULFILLED",
        payload: data,
        count:
          typeof countFromApi === "number"
            ? countFromApi
            : Array.isArray(data)
            ? data.length
            : 0,
        currentBalance:
          typeof currentBalanceFromApi === "number"
            ? currentBalanceFromApi
            : null,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USER_WALLET_DETAILS_REJECTED",
        payload: error.response,
      });
    }
  };

  export const getAllZoneList =
  (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_ZONE_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Zone-List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_MASTER_ZONE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_MASTER_ZONE_REJECTED",
        payload: error.response,
      });
    }
  };